/* bb-size-rail.js — Phase 1, Step 4 (multi-instance).

   Builds size-aware product rails from assets/bb-size-index.json.

   TWO instances render on a PDP and both run off this file, so everything below is
   per-instance. An earlier version assumed a single `[data-bb-rail]` and silently
   left the second rail empty.
     mode="all"       -> "Also available in your size", sits under Add to Cart
     mode="store999"  -> "Pair it from the 999 Store", sits in the PDP tail section

   Rules from the brief:
   - Hidden until a size is known (BBSize profile, or the size chosen on this PDP)
   - Excludes the current product, anything already in cart, and — via the index —
     out-of-stock, qty<=2 and return-blocklisted variants
   - Index fetched AFTER DOMContentLoaded, non-blocking; LCP has ~500ms of headroom
   - Height reserved in CSS before render, so CLS stays 0
   - Failure is silent: the rail stays hidden, no error UI
   - Adds go through /cart/add.js with `_source: "size-rail"`, then dispatch
     bb:section-reloaded so the GoKwik drawer opens like everywhere else
*/
(function () {
  'use strict';

  var indexData = null;
  var cartVariants = [];
  var instances = [];

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function money(v) { return 'Rs. ' + Number(v).toLocaleString('en-IN'); }

  // Colour swatches soft-navigate: URL changes to another product with no reload,
  // so anything baked in at render time goes stale. Read the handle from the URL.
  function currentHandle(fallback) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : fallback;
  }

  var typeCache = {};
  function fetchType(handle) {
    if (typeCache[handle] !== undefined) return Promise.resolve(typeCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { typeCache[handle] = (p && p.type) || null; return typeCache[handle]; })
      .catch(function () { typeCache[handle] = null; return null; });
  }

  function knownType(handle, bakedHandle) {
    if (typeCache[handle] !== undefined) return typeCache[handle];
    var live = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta
      && window.ShopifyAnalytics.meta.product || {});
    if (live.type && bakedHandle === handle) { typeCache[handle] = live.type; return live.type; }
    return undefined;
  }

  function currentPdpSize() {
    var checked = document.querySelector('.bb-size-pill input:checked');
    if (!checked) return null;
    var pill = checked.closest('.bb-size-pill');
    var raw = (pill && pill.getAttribute('data-size')) || checked.value;
    return window.BBSize ? window.BBSize.tokenise(raw) : null;
  }

  /* ------------------------------------------------------------ instance --- */
  function Rail(root) {
    var track = root.querySelector('[data-bb-rail-track]');
    var mode = root.getAttribute('data-mode') || 'all';
    var bakedHandle = root.getAttribute('data-current-handle');
    var maxCards = parseInt(root.getAttribute('data-max-cards') || '12', 10);

    function resolve(typeOverride) {
      if (!window.BBSize) return null;
      var handle = currentHandle(bakedHandle);
      var type = typeOverride !== undefined ? typeOverride : knownType(handle, bakedHandle);
      if (type === undefined) return undefined;          // caller fetches
      var category = window.BBSize.classify(type, document.title);
      if (!category) return null;

      var pdpToken = currentPdpSize();
      var bb = document.querySelector('.beyours-bb');
      var lenIdx = bb ? parseInt(bb.getAttribute('data-bb-length-idx') || '-1', 10) : -1;

      var keys;
      if (pdpToken) {
        var len = null;
        if (lenIdx >= 0) {
          var lp = document.querySelector('.bb-length-pill input:checked');
          var w = lp && lp.closest('.bb-length-pill');
          if (w) len = w.getAttribute('data-length');
        }
        keys = (category === 'bottom' && len) ? [pdpToken + '|' + len, pdpToken] : [pdpToken];
      } else {
        keys = window.BBSize.keys(category);
      }
      if (!keys.length) return null;
      return { category: category, keys: keys, token: keys[0].split('|')[0] };
    }

    // Find what the shopper is looking at, so the pool can be ranked by closeness.
    function hereMeta(handle) {
      var out = { collection: null, type: null };
      var buckets = [indexData.tops, indexData.bottoms];
      for (var i = 0; i < buckets.length; i++) {
        for (var k in buckets[i]) {
          var list = buckets[i][k];
          for (var j = 0; j < list.length; j++) {
            if (list[j].h === handle) { out.collection = list[j].c; out.type = list[j].t; return out; }
          }
        }
      }
      return out;
    }

    function pool(res) {
      var bucket = res.category === 'top' ? indexData.tops : indexData.bottoms;
      var here = currentHandle(bakedHandle);
      var seen = {}, out = [];

      res.keys.forEach(function (k) {
        (bucket[k] || []).forEach(function (e) {
          if (e.h === here) return;
          if (cartVariants.indexOf(e.v) !== -1) return;
          if (mode === 'store999' && !e.s9) return;      // deal products only
          if (seen[e.v]) return;
          seen[e.v] = 1;
          out.push(e);
        });
      });

      // Relevance before raw rank: someone viewing a shirt wants shirts. The signal
      // is already in the index — collection name first, then product type. No model
      // required, and nothing is computed at request time.
      var meta = hereMeta(here);
      function tier(e) {
        if (meta.collection && e.c === meta.collection) return 0;   // same range
        if (meta.type && e.t === meta.type) return 1;               // same type
        return 2;
      }
      out.sort(function (a, b) {
        var d = tier(a) - tier(b);
        return d !== 0 ? d : (b.r - a.r);
      });
      return out;
    }

    function seeAllUrl(token) {
      if (mode === 'store999') return '/pages/beyours-sale-buy-2-at-1999';
      var base = root.getAttribute('data-collection-url') || '/collections/all-collection-beyours';
      var values = (indexData.size_values || {})[token] || [token];
      var qs = ['filter.v.availability=1'];
      values.forEach(function (v) { qs.push('filter.v.option.size=' + encodeURIComponent(v)); });
      return base + (base.indexOf('?') === -1 ? '?' : '&') + qs.join('&');
    }

    function card(e) {
      var a = document.createElement('div');
      a.className = 'bb-rail__card';
      a.setAttribute('data-variant-id', e.v);
      var img = e.i
        ? '<img src="https://' + e.i + '&width=280" alt="" loading="lazy" decoding="async" width="128" height="160">'
        : '';
      var was = e.cp && e.cp > e.p ? '<s>' + money(e.cp) + '</s>' : '';
      var collection = e.c || e.t || '';
      a.innerHTML =
        '<a class="bb-rail__media" href="/products/' + e.h + '">' + img + '</a>' +
        (collection ? '<a class="bb-rail__collection" href="/products/' + e.h + '">' + collection + '</a>' : '') +
        '<a class="bb-rail__title" href="/products/' + e.h + '">' + (e.n || '') + '</a>' +
        '<span class="bb-rail__price">' + money(e.p) + was + '</span>' +
        '<button type="button" class="bb-rail__add" data-bb-rail-add>Add</button>';
      return a;
    }

    function render(res, list) {
      var shown = list.slice(0, maxCards);
      if (!shown.length) { root.hidden = true; return; }

      var frag = document.createDocumentFragment();
      shown.forEach(function (e) { frag.appendChild(card(e)); });

      if (list.length > shown.length) {
        var more = document.createElement('a');
        more.className = 'bb-rail__more';
        more.href = seeAllUrl(res.token);
        more.textContent = mode === 'store999'
          ? 'See the whole 999 Store →'
          : 'See all ' + list.length + ' in ' + res.token + ' →';
        frag.appendChild(more);
      }

      track.innerHTML = '';
      track.appendChild(frag);
      var label = root.querySelector('[data-bb-rail-size]');
      if (label) label.textContent = '(' + res.token + ')';
      root.hidden = false;
      if (mode === 'all') relocate();
    }

    // Only the "all" rail moves — it belongs in the buy box. The 999 rail stays where its
    // section renders, at the tail of the PDP.
    //
    // It goes BELOW the Details/Reviews/Delivery/Returns accordion, not directly under Add
    // to Bag. Those four rows answer the questions a customer has about the product they
    // already chose; the rail offers different products. Putting the rail first pushed the
    // answers off the screen and interrupted the decision with a distraction.
    //
    // The accordion is the preferred anchor, with the Add to Bag block as the fallback for
    // any PDP that renders no accordion (a product with no description, no reviews and no
    // delivery copy) — there the rail still belongs under the button.
    function relocate() {
      if (document.contains(root) && root.closest('.beyours-bb')) return;
      var anchor = document.querySelector('.beyours-bb .bb-accordion-section');
      if (!anchor) {
        var atc = document.querySelector('[data-bb-atc-desktop]') || document.querySelector('[data-bb-atc]');
        if (!atc) return;
        anchor = atc.closest('.bb-section') || atc.parentElement;
      }
      if (!anchor || !anchor.parentNode) return;
      anchor.parentNode.insertBefore(root, anchor.nextSibling);
    }

    function build() {
      if (!indexData) return;
      var res = resolve();
      if (res === undefined) {
        return fetchType(currentHandle(bakedHandle)).then(function (t) {
          var r2 = resolve(t);
          if (!r2) { root.hidden = true; return; }
          render(r2, pool(r2));
        });
      }
      if (!res) { root.hidden = true; return; }
      render(res, pool(res));
    }

    function reserveIfKnown() {
      if (mode !== 'all') return;                       // tail section reserves its own space
      if (window.BBSize && resolve()) { relocate(); root.hidden = false; }
    }

    return { root: root, mode: mode, build: build, relocate: relocate, reserveIfKnown: reserveIfKnown,
             clear: function () { track.innerHTML = ''; root.hidden = true; } };
  }

  /* --------------------------------------------------------------- add ---- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-bb-rail-add]');
    if (!btn || btn.disabled) return;
    var cardEl = btn.closest('.bb-rail__card');
    var id = cardEl && Number(cardEl.getAttribute('data-variant-id'));
    if (!id) return;

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _source: 'size-rail' } }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-done');
        cartVariants.push(id);
        document.dispatchEvent(new CustomEvent('bb:section-reloaded'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { btn.disabled = false; btn.textContent = original; });
  });

  /* -------------------------------------------------------------- boot ---- */
  function buildAll() { instances.forEach(function (i) { i.build(); }); }

  ready(function () {
    var roots = [].slice.call(document.querySelectorAll('[data-bb-rail]'));
    if (!roots.length) return;
    instances = roots.map(Rail);

    var first = roots[0];
    var url = first.getAttribute('data-index-url');

    instances.forEach(function (i) { i.reserveIfKnown(); });

    Promise.all([
      fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('index ' + r.status);
        return r.json();
      }),
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return (c.items || []).map(function (i) { return i.variant_id; }); })
        .catch(function () { return []; })
    ])
      .then(function (r) {
        indexData = r[0];
        cartVariants = r[1];
        buildAll();

        // The buy box is replaced wholesale on a colour-swatch soft-nav, taking the
        // relocated "all" rail with it. Watch for it going missing and put it back.
        var t = null;
        new MutationObserver(function () {
          var missing = instances.filter(function (i) { return !document.contains(i.root); });
          if (!missing.length) return;
          clearTimeout(t);
          t = setTimeout(function () {
            if (!document.querySelector('.beyours-bb')) return;
            missing.forEach(function (i) {
              if (document.contains(i.root)) return;
              i.clear();
              i.relocate();
              i.build();
            });
          }, 120);
        }).observe(document.body, { childList: true, subtree: true });

        document.addEventListener('bb:size-changed', buildAll);
        document.addEventListener('bb:section-reloaded', buildAll);
        document.addEventListener('change', function (e) {
          if (e.target.closest && e.target.closest('.bb-size-pill, .bb-length-pill')) buildAll();
        });
      })
      .catch(function () { /* silent — rails stay hidden */ });
  });
})();
